import styled from 'styled-components';
import NativeLink from '../../common/NativeLink';

const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: space-around;
  padding: 1em 4em 4em 4em;
  background-color: ${(props) => props.theme.color.neutral.v100};
  text-align: center;
  font-weight: 700;
  font-size: 20px;
`;

const SadCarImage = styled.img`
  padding: 30px 0 10px 0;
  width: 50px;
`;

const ModalMessage = styled.div`
  color: ${(props) => props.theme.color.neutral.v500};
  padding: 20px 0 30px 0;
  text-align: center;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
`;
const SupportMessage = styled.div`
  color: ${(props) => props.theme.color.primary.v700};
  background-color: ${(props) => props.theme.color.neutral.v200};
  padding: 20px 0;
  width: 100%;
  text-align: center;
  font-weight: 500;
  font-size: 18px;
  line-height: 28px;

  & a {
    color: ${(props) => props.theme.color.primary.v200};
  }
`;

const HyperLink = styled(NativeLink)`
  color: ${(props) => props.theme.color.primary.v200};
  text-decoration: underline;
`;

export { ModalContent, ModalMessage, SupportMessage, SadCarImage, HyperLink };
